import React from "react";
import { Row, Col } from "reactstrap";
// import STYLES from '../STYLES';
import MVRForm from "./MVRForm";

export class MVRContent extends React.Component {
    render() {
        return (
            <div>
                <Row>
                    <Col xs="12" style={{ margin: "10px auto", fontSize: 12 }}>
                        <h5
                            style={{
                                marginTop: 5,
                                marginBottom: 10,
                                textAlign: "center"
                            }}
                        >
                            {"MVR"}
                        </h5>
                        <MVRForm />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default MVRContent;
